<template>
    <div class="card-container-new">
        <div 
        class="card-info"  
        :style="[
                training.data.cover != ''
                  ? {
                      'background-image': `url('${getCoverURL(training.data.cover, training.rented)}')`,
                    }
                  : {},
              ]"
            >
            <div class="header">
                <div class="tag-container">
                    <div class="tag-wrapper">
                        <div class="warning">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="10" stroke="#FF383C" stroke-width="1.5"/>
                                <path d="M12 7V13" stroke="#FF383C" stroke-width="1.5" stroke-linecap="round"/>
                                <circle cx="12" cy="16" r="1" fill="#FF383C"/>
                            </svg>
                        </div>
                        <div class="tag">
                            Privaloma
                        </div>
                    </div>
                </div>
                <div class="options-container" v-if="editMode" @click.stop="activeOptionMenu = training.id">
                    <svg width="3" height="14" viewBox="0 0 3 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.00173225 1.33504C0.00138978 1.07138 0.0780175 0.813541 0.221925 0.594129C0.365833 0.374717 0.570557 0.203586 0.810209 0.102377C1.04986 0.00116707 1.31368 -0.0255752 1.5683 0.0255316C1.82292 0.0766383 2.0569 0.203299 2.24067 0.389496C2.42443 0.575692 2.54972 0.813063 2.60069 1.07159C2.65166 1.33012 2.62602 1.59819 2.52702 1.84191C2.42801 2.08563 2.26009 2.29405 2.04448 2.44081C1.82887 2.58757 1.57526 2.66608 1.31572 2.66642C0.967687 2.66687 0.633728 2.52685 0.387307 2.27717C0.140887 2.02749 0.00219148 1.68859 0.00173225 1.33504ZM1.31961 5.66586C1.06008 5.6662 0.806466 5.74471 0.590857 5.89147C0.375248 6.03823 0.207323 6.24665 0.108318 6.49037C0.00931293 6.73409 -0.0163259 7.00216 0.0346436 7.26069C0.0856131 7.51922 0.210902 7.75659 0.394666 7.94278C0.578431 8.12898 0.812417 8.25564 1.06704 8.30675C1.32166 8.35785 1.58547 8.33111 1.82512 8.2299C2.06478 8.12869 2.2695 7.95756 2.41341 7.73815C2.55732 7.51874 2.63394 7.2609 2.6336 6.99724C2.63314 6.64368 2.49445 6.30479 2.24803 6.05511C2.00161 5.80542 1.66765 5.66541 1.31961 5.66586ZM1.32697 11.3315C1.06743 11.3318 0.813825 11.4103 0.598216 11.5571C0.382607 11.7038 0.214682 11.9123 0.115677 12.156C0.016672 12.3997 -0.00896688 12.6678 0.0420026 12.9263C0.0929722 13.1848 0.218261 13.4222 0.402026 13.6084C0.58579 13.7946 0.819776 13.9213 1.0744 13.9724C1.32901 14.0235 1.59283 13.9967 1.83248 13.8955C2.07214 13.7943 2.27686 13.6232 2.42077 13.4038C2.56467 13.1843 2.6413 12.9265 2.64096 12.6629C2.6405 12.3093 2.5018 11.9704 2.25538 11.7207C2.00896 11.471 1.67501 11.331 1.32697 11.3315Z" fill="white"/>
                    </svg>
                </div>
                <div
                  class="option-menu"
                  v-click-outside-2="closeMenu"
                  v-if="showMenu(training)"
                >
                  <div 
                  v-if="showMenuItem(training,'view')" 
                  class="color option-block" 
                  v-tooltip="{content: toLocal('emails.training_inv_btn'), classes: 'tooltip-container icon-tooltip'}"
                  @click.stop="training.data.trainingType !='attest' ? openTraining(training.id, training) :  editTraining(training.id, null, training.created_by)"
                  
                  >
                    <HomeEditEditTrainingSvg v-if="training.data.trainingType =='attest'" class="stroke" />
                    <svg v-else width="30" height="16" viewBox="0 0 30 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M28 8.00205C26.448 10.1736 24.4303 11.9373 22.1079 13.1523C19.7855 14.3673 17.2226 15 14.6238 15C12.0251 15 9.46252 14.3673 7.14014 13.1523C4.81777 11.9373 2.80006 10.1736 1.24805 8.00205C2.79935 5.82939 4.8165 4.06471 7.13897 2.84896C9.46143 1.6332 12.0247 1 14.6238 1C17.223 1 19.7862 1.6332 22.1087 2.84896C24.4312 4.06471 26.4487 5.82939 28 8.00205Z" stroke="#707070" stroke-width="2" stroke-miterlimit="10"/>
                      <path d="M14.624 12.5807C17.0521 12.5807 19.0205 10.5301 19.0205 8.00039C19.0205 5.47074 17.0521 3.42004 14.624 3.42004C12.1959 3.42004 10.2275 5.47074 10.2275 8.00039C10.2275 10.5301 12.1959 12.5807 14.624 12.5807Z" stroke="#707070" stroke-width="2" stroke-miterlimit="10"/>
                    </svg>
                  </div>
                  <div class="pencil option-block" v-tooltip="{content: toLocal('trainings.added_users'), classes: 'tooltip-container icon-tooltip'}" @click.stop="openGroupSide(training)" 
                  v-if="showMenuItem(training,'users')">
                    <HomeEditOpenGroupSvg class="stroke" />
                  </div>
                  <div class="trash option-block" v-tooltip="{content: toLocal('training.training_stats'), classes: 'tooltip-container icon-tooltip'}" @click.stop="trainingStats(training, training.id, training.rented)" 
                  v-if="showMenuItem(training,'stats')">
                    <HomeEditStatsSvg class="stroke fill-gray" />
                  </div>
                  <div class="option-block" v-tooltip="{content: toLocal('training.delete_training_label'), classes: 'tooltip-container icon-tooltip'}" @click.stop="deleteTraining(training.id)" v-if="showMenuItem(training,'delete')">
                    <HomeEditDeleteTrainingSvg class="stroke smaller" />
                  </div>
                  <div class="option-block" v-tooltip="{content: toLocal('training.copy_training'), classes: 'tooltip-container icon-tooltip'}" @click.stop="copyTraining(training.id)" v-if="showMenuItem(training,'copy')">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19.1667 0H5.83333C5.61232 0 5.40036 0.0877975 5.24408 0.244078C5.0878 0.400358 5 0.61232 5 0.833333V5H0.833333C0.61232 5 0.400358 5.0878 0.244078 5.24408C0.0877975 5.40036 0 5.61232 0 5.83333V19.1667C0 19.3877 0.0877975 19.5996 0.244078 19.7559C0.400358 19.9122 0.61232 20 0.833333 20H14.1667C14.3877 20 14.5996 19.9122 14.7559 19.7559C14.9122 19.5996 15 19.3877 15 19.1667V15H19.1667C19.3877 15 19.5996 14.9122 19.7559 14.7559C19.9122 14.5996 20 14.3877 20 14.1667V0.833333C20 0.61232 19.9122 0.400358 19.7559 0.244078C19.5996 0.0877975 19.3877 0 19.1667 0ZM13.3333 18.3333H1.66667V6.66667H13.3333V18.3333ZM18.3333 13.3333H15V5.83333C15 5.61232 14.9122 5.40036 14.7559 5.24408C14.5996 5.0878 14.3877 5 14.1667 5H6.66667V1.66667H18.3333V13.3333Z" fill="#7D7D7D"/>
                    </svg>
                  </div>
                  <div class="option-block" v-tooltip="{content: toLocal('training.move_training'), classes: 'tooltip-container icon-tooltip'}" @click.stop="moveTraining(training.id)" v-if="showMenuItem(training,'move')">
                    <svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22.988 6.5H21.9765C19.7172 6.5 19.7208 3.25 18.1248 3.25H8.51025C6.71125 3.25 5.25 4.60688 5.25 6.279V9.75H7V6.279C7 5.5055 7.679 4.875 8.51025 4.875H17.7922C17.9007 5.031 18.039 5.265 18.1387 5.43887C18.725 6.44312 19.7067 8.125 21.9765 8.125H22.988C23.765 8.125 24.5 8.91475 24.5 9.75V19.7226C24.5 20.4945 23.821 21.125 22.988 21.125H8.51025C7.679 21.125 7 20.4945 7 19.7226V17.875H5.25V19.7226C5.25 21.3948 6.71125 22.75 8.51025 22.75H22.9863C24.7888 22.75 26.25 21.3948 26.25 19.7226V9.75C26.25 8.07787 24.7887 6.5 22.988 6.5Z" fill="#707070"/>
                      <path d="M13.5993 17.6172L17.2376 14.3201C17.2411 14.3168 17.2428 14.3119 17.2463 14.3071C17.3233 14.2356 17.3881 14.0649 17.4318 13.9707C17.4686 13.8829 17.4826 13.9544 17.4896 13.8667C17.4896 13.8472 17.5001 13.8309 17.5001 13.8131C17.5001 13.8001 17.4931 13.7903 17.4931 13.7789C17.4878 13.6814 17.4686 13.6327 17.4318 13.5417C17.3951 13.4588 17.3356 13.3889 17.2743 13.3223C17.2603 13.3061 17.2533 13.2833 17.2376 13.2687L13.5993 9.89357C13.2493 9.56695 12.6806 9.71645 12.3306 10.0431C11.9788 10.3681 11.9788 10.8962 12.3306 11.2228L14.4323 13.0249L2.68459 13.0266C2.17184 13.0266 1.75534 13.3516 1.75709 13.8114C1.75534 14.2713 2.17184 14.5654 2.68634 14.5654H14.4341L12.3323 16.5853C11.9806 16.9119 11.9806 17.4384 12.3323 17.7667C12.5073 17.9292 12.7348 17.8626 12.9658 17.8626C13.1968 17.8626 13.4261 17.7781 13.5993 17.6172Z" fill="#707070"/>
                    </svg>

                  </div>
                </div>
            </div>
            <div class="training-title">
                <p>
                    {{ training.data.title }}
                </p>
            </div>
            <div class="info-wrapper">
                <div class="duration">
                    {{duration}}
                </div>
                <div class="progress-container">
                    <div class="progress-line">
                        <span 
                            class="progress"
                            v-if="!editMode"
                            :style="[{
                                width: progress+'%'
                            },
                            progress > 20
                            ]"
                        >
                        </span>
                    </div>
                    <div class="progress-percent" v-if="!editMode">{{ progress }} %</div>
                </div>
            </div>
        </div>
        <div class="action-container">
            <div class="term-container" v-if="!editMode">

            </div>
            <div class="editor-container" v-else>
                <VTooltip :triggers="['hover']" theme="new-tooltip" :placement="'bottom'">
                        <div class="bubble">
                            <span class="initials">
                                {{ userInitials }}
                            </span>
                        </div>
                        <template #popper>
                            <div class="user-data">
                                <div class="user">
                                    <span class="label">
                                        Redaguota
                                    </span>
                                    <span class="user-name">
                                        {{ training.edit_data.updated_by ?  training.edit_data.updated_by.name + ' '+ training.edit_data.updated_by.last_name : ''}}
                                    </span>
                                    <span class="date">
                                        {{ training.edit_data.updated_at }}
                                    </span>
                                </div>
                                <div class="user">
                                    <span class="label">
                                        Sukūrė
                                    </span>
                                    <span class="user-name">
                                        {{ training.edit_data.created_by ?  training.edit_data.created_by.name + ' '+ training.edit_data.created_by.last_name : ''}}
                                    </span>
                                     <span class="date">
                                        {{ training.edit_data.created_at }}
                                    </span>
                                </div>
                            </div>
                        </template>
                </VTooltip>
            </div>
            <div class="action-button">
                <button class="action" @click="goToTraining">
                    {{ editMode ? 'Pradėti' : training.user_training_status == 0 ? 'Pradėti' : 'Tęsti' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import HomeEditSearchSvg from "@/assets/images/icons/homeEdit/home-edit-search.svg?inline";
import HomeEditSearchCancelSvg from "@/assets/images/icons/homeEdit/home-edit-search-cancel.svg?inline";
import HomeEditAddSvg from "@/assets/images/icons/homeEdit/home-edit-add.svg?inline";
import HomeEditDeleteSvg from "@/assets/images/icons/homeEdit/home-delete-widthless.svg?inline";
import HomeEditArrowDownSvg from "@/assets/images/icons/homeEdit/home-edit-arrow-down.svg?inline";
import HomeEditArrowUpSvg from "@/assets/images/icons/homeEdit/home-edit-arrow-up.svg?inline";
import HomeEditPlaySvg from "@/assets/images/icons/homeEdit/home-edit-play.svg?inline";
import HomeEditEditTrainingSvg from "@/assets/images/icons/homeEdit/home-edit-widthless.svg?inline";
import HomeEditOpenGroupSvg from "@/assets/images/icons/homeEdit/home-edit-group-widthless.svg?inline";
import HomeEditStatsSvg from "@/assets/images/icons/homeEdit/home-edit-stats-widthless.svg?inline";
import HomeEditDeleteTrainingSvg from "@/assets/images/icons/homeEdit/home-delete-widthless.svg?inline";
export default {
    name: 'TrainingCard',
    props:{
        training:{
            type: Object,
            default: () => ({})
        },
        editMode:{
            type: Boolean,
            default: false
        }
    },
    components:{
        HomeEditSearchSvg,
        HomeEditSearchCancelSvg,
        HomeEditAddSvg,
        HomeEditDeleteSvg,
        HomeEditArrowDownSvg,
        HomeEditArrowUpSvg,
        HomeEditPlaySvg,
        HomeEditEditTrainingSvg,
        HomeEditOpenGroupSvg,
        HomeEditStatsSvg,
        HomeEditDeleteTrainingSvg,
    },
    computed:{
        duration(){
            let minutes = parseInt(this.training.data ? this.training.data.time : 0);
            let hours = 0
            if(minutes >= 60){
                hours = minutes % 60;
                minutes = minutes - (hours*60);
            }
            return `${hours > 0 ? hours + ' val. ' : ''}${minutes > 0 ? minutes + ' min.' : ''}`
        },
        userInitials(){
            let initials = '';
            let user = this.training.edit_data ? this.training.edit_data.updated_by : null;
            if(user){
                initials = user.name[0]+(user.last_name ? user.last_name[0] : '')
            }

            return initials;
        }
    },
    data() {
        return {
            progress: 52,
            activeOptionMenu: -1
        };
    },

    mounted() {
        if(this.training.user_training_status == 2){
            this.progress = 100;
        }
        if(this.training.user_training_status == 0){
            this.progress = 0;
        }
    },

    methods: {
        getCardStyle(training) {
            let style = {};
            if (this.$store.state.system_settings.custom_style && this.$store.state.system_settings.custom_style.training_card_style && this.$store.state.system_settings.custom_style.training_card_style) { 
            if (this.$store.state.system_settings.custom_style.training_card_style['font-weight']) {
                style['font-weight'] = this.$store.state.system_settings.custom_style.training_card_style['font-weight'];
                }
            }
            return style;
        },
        getCoverURL(cover, rented){
            if(this.type=='paid' || rented==1){
                let protocol = this.$store.state.ssl ? 'https://' : 'http://';
                return protocol +  process.env.VUE_APP_PARENT_LMS_API + '/uploads/' + cover;
            }
            else{
                return this.getFileUrl(cover)
            }
        },
        openTrainingFunction(){

        },
        getTrainingTime(time) {
            let minutes = time;
            let hours = Math.floor(minutes / 60);
            minutes = minutes % 60;
            return hours > 0 ? hours + " val. " + minutes + " min" : minutes + " min";
        },
        showMenu(training, type = 'default'){
            if(type == 'dots' && (this.$store.state.user_role == 'admin' || this.hasPermission('users.assign_trainings') || this.hasPermission('trainings.edit') || this.hasPermission('users.view_stats'))){
                if(this.$store.state.system_settings.trainingOptions && this.$store.state.system_settings.trainingOptions.showMenu != undefined){
                    return this.$store.state.system_settings.trainingOptions.showMenu;
                }
                return true
            }
            if((this.$store.state.user_role == 'admin' || this.hasPermission('users.assign_trainings') || this.hasPermission('trainings.edit') || this.hasPermission('users.view_stats')) && (this.activeOptionMenu == training.id)){
                if(this.$store.state.system_settings.trainingOptions && this.$store.state.system_settings.trainingOptions.showMenu != undefined){
                    return this.$store.state.system_settings.trainingOptions.showMenu;
                }
                return true;
            }
            return false;
        },
        showMenuItem(training, type){
            if(type == 'view'){
                if(this.$store.state.system_settings.trainingOptions && this.$store.state.system_settings.trainingOptions.menu && this.$store.state.system_settings.trainingOptions.menu.view != undefined){
                    return this.$store.state.system_settings.trainingOptions.menu.view
                }
                return true;
            }
            if(type == 'users'){
                if((this.$store.state.user_role == 'admin' || this.hasPermission('users.assign_trainings')) && (training && training.data ? training.data.trainingType != 'attest' : true)){
                    if(this.$store.state.system_settings.trainingOptions && this.$store.state.system_settings.trainingOptions.menu && this.$store.state.system_settings.trainingOptions.menu.users != undefined){
                        return this.$store.state.system_settings.trainingOptions.menu.users
                    }
                    return true;
                }
                else{
                    return false
                }
            }
            if(type == 'stats'){
                if(this.$store.state.user_role == 'admin' || this.hasPermission('users.view_stats')){
                    if(this.$store.state.system_settings.trainingOptions && this.$store.state.system_settings.trainingOptions.menu && this.$store.state.system_settings.trainingOptions.menu.stats != undefined){
                        return this.$store.state.system_settings.trainingOptions.menu.stats
                    }
                    return true;
                }
                else{
                    return false
                }
            }
            if(type == 'delete'){
                if(this.showDeleteButton(training)){
                    if(this.$store.state.system_settings.trainingOptions && this.$store.state.system_settings.trainingOptions.menu && this.$store.state.system_settings.trainingOptions.menu.delete != undefined){
                        return this.$store.state.system_settings.trainingOptions.menu.delete
                    }
                    return true;
                }
                else{
                    return false
                }
            }
            if(type == 'copy'){
                if(this.showDeleteButton(training)){
                    if(this.$store.state.system_settings.trainingOptions && this.$store.state.system_settings.trainingOptions.menu && this.$store.state.system_settings.trainingOptions.menu.delete != undefined){
                        return this.$store.state.system_settings.trainingOptions.menu.delete
                    }
                    return true;
                }
                else{
                    return false
                }
            }
            if(type == 'move'){
                if(this.showDeleteButton(training)){
                    if(this.$store.state.system_settings.trainingOptions && this.$store.state.system_settings.trainingOptions.menu && this.$store.state.system_settings.trainingOptions.menu.delete != undefined){
                        return this.$store.state.system_settings.trainingOptions.menu.delete
                    }
                    return true;
                }
                else{
                    return false
                }
            }
        },
        goToTraining(){
            if(this.editMode){
                this.$emit('editTraining', this.training.id, null,this.training.created_by)
            }
            else{
                this.$emit('openTraining', this.training.id, this.training)
            }
        },
        openTraining(id, training) {
            this.$emit('openTraining', id, training)
        },
        editTraining(id, query = null, created_by = null) {
            this.$emit('editTraining', id, query,created_by)
        },
        moveTraining(id){
            this.$emit('moveTraining', id)
        },
        copyTraining(id){
            this.$emit('copyTraining', id)
        },
        deleteTraining(id){
            this.$emit('deleteTraining', id)
        },
        closeMenu(){
             setTimeout(() => {
                if (this.activeOptionMenu != -1) {
                    this.activeOptionMenu = -1;
                }
            }, 200);
        },
        showDeleteButton(training) {
            if (this.$store.state.user_role == 'admin') return true;
            let show = false;
            let edit_permission = this.hasPermission('trainings.edit');
            if (edit_permission) {
            
                if (this.hasPermission('trainings.edit_own')) {
                    let created_by = training.created_by;
                    if (created_by == this.$store.state.user_id) {
                        show = true;
                    }
                }
                else show = true;
                if (this.$store.state.user_permissions['trainings.edit_in_groups']) {
                    let ids = this.$store.state.user_permissions['trainings.edit_in_groups'].items;
                    if (ids.includes(this.trainingGroup.id) || this.$store.state.user_permissions['trainings.edit_in_groups'].all_selected) {
                        show = true;
                    }
                    else show = false;
                }
            }
            else {
                show = false;
            }
            return show;
            
        },
    },
};
</script>

<style lang="scss" scoped>
.card-container-new{
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 20px 0 rgba(225, 218, 255, 1);
    border-radius: 1rem;
    width: 300px;
    aspect-ratio: 75 / 64;
    // overflow: hidden;
}
.card-info{
    display: flex;
    position: relative;
    flex-direction: column;
    padding: 11px 13px;
    background-image: url("../../../assets/images/placeholders/pia21974.0.jpg");
    background-size: cover;
    background-position: center;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    height: 77.3%;
    &::before{
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border-top-left-radius: 1rem;
        border-top-right-radius: 1rem;
        background: linear-gradient(104.37deg, rgba(255, 255, 255, 0) -23.7%, rgba(34, 7, 147, 0.49) 77.38%);
        backdrop-filter: blur(2px);
    }
    .tag-container{
        display: flex;
        align-items: center;
        padding: 0.4rem 0.5rem;
        border-radius: 1.5rem;
        backdrop-filter: blur(8px);
        width: fit-content;
        background-color: rgba(255, 255, 255, 0.35);
        .tag-wrapper{
            display: flex;
            align-items: center;
            gap: 8px;
        }
        .warning{
            display: flex;
        }
        .tag{
            background-color: white;
            padding: 7px 15px;
            font-weight: 500;
            border-radius: 1rem;
            font-family: 'Poppins', var(--main-site-font);
            font-size: 11px;
            color: #FF0000
        }
    }
}
.options-container{
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    z-index: 2;
    right: 13px;
    top: 27px;
    height: 17px;
    width: 17px;
    cursor: pointer;
}
.action-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 23.7%;
    padding: 15px 12px;
}
.action{
    display: flex;
    align-items: center;
    color: white;
    background-color: #624DE3;
    border: none;
    height: 1.6rem;
    padding: 0 29px;
    border-radius: 38px;
    font-weight: bold;
    font-family: 'Manrope', var(--main-site-font);
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.3s ease;
    &:hover{
        background-color: #6f5de4;
    }
    &:active{
        transform: scale(0.95);
    }
}
.bubble{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    width: 24px;
    background: linear-gradient(283.19deg, #AD9AFF 12.32%, #E1DAFF 135.48%);
    border-radius: 50%;
    .initials{
        font-weight: 900;
        font-family: 'Manrope', var(--main-site-font);
        font-size: 10px;
        color: white;
    }
}
.training-title{
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    font-size: 18px;
    font-weight: 600;
    font-family: 'Poppins', var(--main-site-font);
    line-height: 24px;
    color: #fff;
    margin-top: 7px;
    height: 100%;
    max-height: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    z-index: 2;
    position: relative;
    p{
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: auto;
        bottom: 0;
        position: absolute;
        height: fit-content;
    }
}
.progress-container{
    display: flex;
    align-items: center;
    align-items: flex-end;
    width: 100%;
    gap: 4px;
    overflow: hidden;
}
.info-wrapper{
    display: flex;
    flex-direction: column;
    gap: 4px;
    z-index: 2;
    margin-top: 8px;
}
.progress{
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 0;
    border-radius: 20px;
    background: linear-gradient(90deg,rgba(255, 109, 67, 1) 3%, rgba(93, 0, 255, 1) 32%, rgba(94, 16, 252, 1) 46%);
    background-size: 600px;
    background-position-x: -26px;
}
.duration{
    color:white;
    font-size: 12px;
    font-weight: 400;
    font-family: 'Poppins', var(--main-site-font);
}
.progress-percent{
    display: flex;
    align-items: center;
    color: white;
    font-size: 500px;
    font-family: 'Poppins', var(--main-site-font);
    font-size: 12px;
    white-space: nowrap;
    margin-bottom: -4px;
}
.progress-line{
    position: relative;
    height: 4px;
    width: 100%;
    border-radius: 20px;
    background-color: #E1DAFF;
}
.option-menu{
  position: absolute;
  right: 2px;
  top: 50px;
  z-index: 20;
  background: #F9F9F9;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform-origin: top;
  animation: expand 0.5s;
  overflow-y: hidden;
  width: 38px;
  max-height: 100%;
  .option-block{
    width: 100%;
    height: 25%;
    min-height: 33px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.25s;
    cursor: pointer;
    &:hover{
      background-color: #d9d9d9;
      .stroke{
        g{
          stroke: #333333;
          fill: white;
          transition: 0s;
        }
        .hover-fill{
          fill: #333333;
        }
        path{
          transition: 0s;
          stroke: #333333;
          fill: white;
        }
      }
    }
    .stroke{
      width: 50%;
      height: 100%;
      min-height: 40px;
      &.smaller{
        height: 60%;
        width: 40%;
      }
    }
  }
}
.user-data{
    display: flex;
    flex-direction: column;
    gap: 16px;
    font-family: 'Manrope', var(--main-site-font);
    padding: 20.5px 18px;
    .user{
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
    .user-name{
        font-size: 13px;
        color:#111827;
    }
    .label{
        margin-bottom: 2px;
        font-size: 12px;
        color:#A6A9AF;   

    }
    .date{
        color:#D2D2D2;
        font-size: 11px;
        font-weight: 400;
    }
}
@keyframes expand {
  from {
    max-height: 0%;
  }
  to {
    max-height: 100%;
  }
}

</style>
<style>
.v-popper--theme-new-tooltip .v-popper__inner {
    background: #ffffff;
    color: #000000;
    padding: 0;
    border: none;
    border-radius: 8px;
    box-shadow: 0px 8px 16px -2px rgba(80, 65, 145, 0.12);
    filter: drop-shadow(0px 0px 24px rgba(98, 77, 227, 0.08));

}
.v-popper--theme-new-tooltip .v-popper__arrow-outer {
    border-color: white;
}
.v-popper--theme-new-tooltip .v-popper__arrow-inner {
    visibility: visible;
    border-color: #ffffff;
}
</style>